import React from 'react';
import IconTriangle from './IconTriangle';

const IconException = (props) => <IconTriangle {...props} />;

IconException.defaultProps = {
    fill: '#E64A49',
};

IconException.displayName = 'Exception';

export default IconException;
